/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import {
  FormControl, Button, IconButton,
  Typography,
  Box,
  Avatar,
  colors,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import moment from 'moment';
import { IEquipmentOption } from '../../../ScheduledServices/ScheduledServicesPlanner/Modals/ServicesForSchedulingFiltersModal';
import { RootState } from '../../../../store/types';
import { IAutocompleteOption } from '../../../../models/iautocompleteOption';

const ServiceDraftsFilterModal: React.FC<{ closeModal: () => void }> = ({ closeModal }) => {
  const dispatch = useDispatch();

  const page = 1;
  const limit = 50;
  const orderBy = "name";
  const order = "asc";

  const [createdAtStartDate, setCreatedAtStartDate] = useState<Date | null>(null);
  const [createdAtEndDate, setCreatedAtEndDate] = useState<Date | null>(null);

  const [modifiedStartDate, setModifiedStartDate] = useState<Date | null>(null);
  const [modifiedEndDate, setModifiedEndDate] = useState<Date | null>(null);
  

  const [searchTextEquipmentModel, setSearchTextEquipmentModel] = useState('');
  const [equipmentsModelsFormatted, setEquipmentsModelsFormatted] = useState<IAutocompleteOption[]>([]);
  const [selectedEquipmentModels, setselectedEquipmentModels] = useState<IAutocompleteOption[]>([]);

  const [placesFormatted, setPlacesFormatted] = useState<IAutocompleteOption[]>([]);
  const [selectedPlaces, setSelectedPlaces] = useState<IAutocompleteOption[]>([]);

  const [searchTextSite, setSearchTextSite] = useState('');
  const [sitesFormatted, setSitesFormatted] = useState<IAutocompleteOption[]>([]);
  const [selectedSites, setSelectedSites] = useState<IAutocompleteOption[]>([]);

  const [searchTextServiceType, setSearchTextServiceType] = useState('');
  const [serviceTypesFormatted, setServiceTypesFormatted] = useState<IAutocompleteOption[]>([]);
  const [selectedServiceTypes, setSelectedServiceTypes] = useState<IAutocompleteOption[]>([]);

  const [searchTextFrequency, setSearchTextFrequency] = useState('');
  const [frequenciesFormatted, setFrequenciesFormatted] = useState<IAutocompleteOption[]>([]);
  const [selectedFrequencies, setSelectedFrequencies] = useState<IAutocompleteOption[]>([]);

  const [searchTextEquipment, setSearchTextEquipment] = useState('');
  const [equipmentsFormatted, setEquipmentsFormated] = useState<IAutocompleteOption[]>([]);
  const [selectedEquipment, setSelectedEquipment] = useState<IAutocompleteOption | null>(null);


  const fetchPlaces = useCallback(
    () => dispatch(actions.fetchPlacesLeafs(selectedSites)),
    [selectedSites]
  );

  const fetchSites = useCallback(
    () => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
    [page, limit, searchTextSite, order, orderBy]
  );

  const fetchEquipmentsModels = useCallback(
    () => dispatch(actions.fetchEquipmentModels(page, limit, searchTextEquipmentModel, order, orderBy)),
    [page, limit, searchTextEquipmentModel, order, orderBy]
  );

  const fetchServiceTypes = useCallback(
    () => dispatch(actions.fetchServiceTypes(page, limit, searchTextServiceType, order, orderBy)),
    [page, limit, searchTextServiceType, order, orderBy]
  );

  const fetchFrequencies = useCallback(
    () => dispatch(actions.fetchFrequency(page, limit, searchTextFrequency, order, orderBy)),
    [page, limit, searchTextFrequency, order, orderBy]
  );

  const sites = useSelector((state: any) => state.sites.sites);
  const places = useSelector((state: any) => state.places.placesLeafs);
  const equipmentsModels = useSelector((state: any) => state.equipmentModels.equipmentModels);
  const serviceTypes = useSelector((state: any) => state.serviceTypes.serviceTypes);
  const frequencies = useSelector((state: any) => state.frequency.frequencies);
  const equipmentsForFilter = useSelector((state: RootState) => state.serviceDrafts.equipmentsForFilters);

  const filteredSites = useSelector((state: any) => state.sites.selectedSitesPlaces);
  const filteredPlaces = useSelector((state: RootState) => state.serviceDrafts.filteredPlaces);
  const filteredEquipmentModels = useSelector((state: RootState) => state.serviceDrafts.filteredModels);
  const filteredServiceTypes = useSelector((state: RootState) => state.serviceDrafts.filteredServiceTypes);
  const filteredFrequencies = useSelector((state: RootState) => state.serviceDrafts.filteredFrequencies);
  const filteredEquipment = useSelector((state: RootState) => state.serviceDrafts.filteredEquipment);
  const filtedCreatedAtStartDate = useSelector((state: RootState) => state.serviceDrafts.filterCreatedAtStart);
  const filtedCreatedAtEndDate = useSelector((state: RootState) => state.serviceDrafts.filterCreatedAtEnd);
  const filtedModifiedStartDate = useSelector((state: RootState) => state.serviceDrafts.filterModifiedAtStart);
  const filtedModifiedEndDate = useSelector((state: RootState) => state.serviceDrafts.filterModifiedAtEnd);

  const loadingSites = useSelector((state: any) => state.sites.loading);
  const loadingEquipmentsModels = useSelector((state: any) => state.equipmentModels.loading);
  const loadingPlaces = useSelector((state: any) => state.places.loading);
  const loadingServiceTypes = useSelector((state: any) => state.serviceTypes.loading);
  const loadingFrequencies = useSelector((state: any) => state.frequency.loading);
  const loadingEquipments = useSelector((state: RootState) => state.serviceDrafts.loadingEquipmentsForFilters);

  const fetchEquipments = useCallback(
    () => dispatch(actions.serviceDraftsFiltersFetchEquipments(page, limit, searchTextEquipment, order, 'equipmentModel.label', filteredSites, filteredPlaces, filteredEquipmentModels)),
    [page, limit, searchTextEquipment, order, orderBy, filteredSites, filteredPlaces, filteredEquipmentModels]
  );

  useEffect(() => {
    handleInputChangeSites(filteredSites.map((site: any) => ({
      value: site._id,
      label: site.name,
      ...site,
    })));
    handleInputChangePlaces(filteredPlaces);
    handleInputChangeEquipmentsModels(filteredEquipmentModels);
    handleInputChangeServiceTypes(filteredServiceTypes);
    handleInputChangeFrequencies(filteredFrequencies);
    handleInputChangeEquipment(filteredEquipment);
    setCreatedAtStartDate(filtedCreatedAtStartDate ? new Date(filtedCreatedAtStartDate) : null);
    setCreatedAtEndDate(filtedCreatedAtEndDate ? new Date(filtedCreatedAtEndDate) : null);
    setModifiedStartDate(filtedModifiedStartDate ? new Date(filtedModifiedStartDate) : null);
    setModifiedEndDate(filtedModifiedEndDate ? new Date(filtedModifiedEndDate) : null);
  }, []);

  useEffect(() => {
    fetchPlaces();
  }, [selectedSites]);

  useEffect(() => {
    fetchSites();
  }, [searchTextSite]);

  useEffect(() => {
    fetchEquipmentsModels();
  }, [searchTextEquipmentModel]);

  useEffect(() => {
    fetchServiceTypes();
  }, [searchTextServiceType]);

  useEffect(() => {
    fetchFrequencies();
  }, [searchTextFrequency]);

  useEffect(() => {
    fetchEquipments();
  }, [searchTextEquipment])

  useEffect(() => {
    setPlacesFormatted(places.rows.map((place: {_id: string, path: string}) => ({ value: place._id, label: place.path })));
  }, [places])

  useEffect(() => {
    setSitesFormatted(
      sites.rows.map((site: any) => ({
        value: site._id,
        label: site.name,
        ...site,
      }))
    );
  }, [sites]);


  useEffect(() => {
    setEquipmentsModelsFormatted(
      equipmentsModels.rows.map((model: any) => ({
        value: model._id,
        label: model.name,
      }))
    );
  }, [equipmentsModels]);


  useEffect(() => {
    setFrequenciesFormatted(
      frequencies.rows.map((frequency: any) => ({
        value: frequency._id,
        label: frequency.name,
      }))
    );
  }, [frequencies]);


  useEffect(() => {
    setServiceTypesFormatted(
      serviceTypes.rows.map((serviceType: any)=> ({
        value: serviceType._id,
        label: serviceType.name,
      }))
    );
  }, [serviceTypes]);


  useEffect(() => {
    setEquipmentsFormated(
      equipmentsForFilter.map((equipment: any) => ({ value: equipment._id, label: equipment.equipmentModel.name, equipment }))
    )
  }, [equipmentsForFilter])

  const handleInputChangeSelectorSites = (text: string) => {
    setSearchTextSite(text);
  }

  const handleInputChangeSelectorEquipmentsModels = (text: string) => {
    setSearchTextEquipmentModel(text);
  }

  const handleInputChangeSelectorServiceTypes = (text: string) => {
    setSearchTextServiceType(text);
  }

  const handleInputChangeSelectorFrequencies = (text: string) => {
    setSearchTextFrequency(text);
  }

  const handleInputChangeSelectorEquipment = (text: string) => {
    setSearchTextEquipment(text);
  }

  const handleInputChangePlaces = (selected: IAutocompleteOption[]) => {
    if (selected) {
      setSelectedPlaces(selected);
    } else {
      setSelectedPlaces([]);
    }
  }

  const handleInputChangeEquipmentsModels = (selected: IAutocompleteOption[]) => {
    if (selected) {
      setselectedEquipmentModels(selected);
    } else {
      setselectedEquipmentModels([]);
    }
  }

  const handleInputChangeServiceTypes = (selected: IAutocompleteOption[]) => {
    if (selected) {
      setSelectedServiceTypes(selected);
    } else {
      setSelectedServiceTypes([]);
    }
  }

  const handleInputChangeFrequencies = (selected: IAutocompleteOption[]) => {
    if (selected) {
      setSelectedFrequencies(selected);
    } else {
      setSelectedFrequencies([]);
    }
  }

  const handleInputChangeSites = (selected: IAutocompleteOption[]) => {
    if(selected) {
      setSelectedSites(selected);
    } else {
      setSelectedSites([]);
    }
  }

  const handleInputChangeEquipment = (selected: IAutocompleteOption | null) => {
    setSelectedEquipment(selected);
  }

  const handleClickFilter = () => {
    dispatch(actions.setSitePlaces(selectedSites));
    dispatch(actions.serviceDraftsSetFilters({
      filteredPlaces: selectedPlaces,
      filteredServiceTypes: selectedServiceTypes,
      filteredFrequencies: selectedFrequencies,
      filteredModels: selectedEquipmentModels,
      filteredEquipment: selectedEquipment,
      filterCreatedAtStart: createdAtStartDate,
      filterCreatedAtEnd: createdAtEndDate,
      filterModifiedAtStart: modifiedStartDate,
      filterModifiedAtEnd: modifiedEndDate
    }));
    closeModal();
  }

  const handleClickClearFilters = () => {
    setSelectedPlaces([])
    setSelectedServiceTypes([])
    setSelectedFrequencies([])
    setCreatedAtStartDate(null);
    setCreatedAtEndDate(null);
    setModifiedStartDate(null);
    setModifiedEndDate(null);
    setSelectedEquipment(null);
    setSelectedSites([]);
  }

  const EquipmentOption = ({ value, label, equipment }: IEquipmentOption) => {
      if (!equipment) return
  
      return (
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
           {equipment.photo?.url ?
          <Avatar src={equipment.photo?.url} />
          :
          <Avatar>
            PHOTO
          </Avatar>
        }
          <Box sx={{marginLeft: '10px'}}>
            <Typography sx={{ fontWeight: 'bold' }}>{label}</Typography>
            <Typography sx={{ fontSize: 12 }}>{i18n.t('scheduledServicesDraggableCard.serialNumber')}{equipment.serialNumber}</Typography>
            <Typography sx={{ fontSize: 12 }}>{i18n.t('scheduledServicesDraggableCard.place')}{equipment.place.path}</Typography>
          </Box>
        </Box>
      )
    }

  return (
    <Box style={styles.container}>
      <Box style={styles.headerContainer}>
        <Box style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
          <FilterList style={{ marginRight: '1rem' }} />
          {i18n.t('filterListModalFilterService.filter') as string}
          {((selectedPlaces && selectedPlaces.length > 0)
          || (selectedEquipmentModels && selectedEquipmentModels.length > 0)
          || (selectedSites && selectedSites.length > 0)
          || (selectedServiceTypes && selectedServiceTypes.length > 0)
          || (selectedFrequencies && selectedFrequencies.length > 0))
          && <Box style={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('filterListModalFilterService.clear') as string}</Box>}
        </Box>
        <IconButton onClick={closeModal} color='inherit' size="large">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box style={styles.bodyContainer}>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingSites}
            label={i18n.t('autocompleteModalFilterService.site')}
            data={sitesFormatted}
            onSelectValue={handleInputChangeSites}
            valueSelected={selectedSites}
            newSearchText={handleInputChangeSelectorSites}
            isMulti
          />
        </FormControl>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingEquipmentsModels}
            label={i18n.t('autocompleteModalFilterService.equipments')}
            data={equipmentsModelsFormatted}
            onSelectValue={handleInputChangeEquipmentsModels}
            valueSelected={selectedEquipmentModels}
            newSearchText={handleInputChangeSelectorEquipmentsModels}
            isMulti
          />
        </FormControl>
          <FormControl variant="standard" fullWidth margin='normal'>
            <Autocomplete
              loading={loadingEquipments}
              label={i18n.t('scheduledServicesServicesForSchedulingFilterModal.equipments')}
              data={equipmentsFormatted}
              onSelectValue={handleInputChangeEquipment}
              valueSelected={selectedEquipment}
              newSearchText={handleInputChangeSelectorEquipment}
              id="equipment"
              customizedOption={EquipmentOption}
              showDataWithoutComponentTextFilter={true}
            />
          </FormControl>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingPlaces}
            label={i18n.t('autocompleteModalFilterService.place')}
            data={placesFormatted}
            onSelectValue={handleInputChangePlaces}
            valueSelected={selectedPlaces}
            newSearchText={() => {}}
            isMulti
          />
        </FormControl>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingServiceTypes}
            label={i18n.t('autocompleteModalFilterService.serviceTypes')}
            data={serviceTypesFormatted}
            onSelectValue={handleInputChangeServiceTypes}
            valueSelected={selectedServiceTypes}
            newSearchText={handleInputChangeSelectorServiceTypes}
            isMulti
          />
        </FormControl>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingFrequencies}
            label={i18n.t('autocompleteModalFilterService.frequencies')}
            data={frequenciesFormatted}
            onSelectValue={handleInputChangeFrequencies}
            valueSelected={selectedFrequencies}
            newSearchText={handleInputChangeSelectorFrequencies}
            isMulti
          />
        </FormControl>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Typography sx={{ marginBottom: '10px', fontWeight: '500', color: '#00000099'}}>{i18n.t('serviceDraftsFilterModal.createdAt') as string}</Typography>
          <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
            <DatePicker
              label={i18n.t('keyboardDatePickerModalFilterService.from') as string}
              value={createdAtStartDate && new Date(createdAtStartDate)}
              onChange={date => setCreatedAtStartDate(date ?  date : null)}
              format="dd/MM/yyyy"
              slotProps={{ textField: { variant: 'standard', } }}
              sx={{ width: '45%', marginRight: '10px'}}
            />
            <DatePicker
              label={i18n.t('keyboardDatePickerModalFilterService.to') as string}
              value={createdAtEndDate && new Date(createdAtEndDate)}
              onChange={date => setCreatedAtEndDate(date ? date : null)}
              format="dd/MM/yyyy"
              slotProps={{ textField: { variant: 'standard', } }}
              sx={{ width: '45%'}}
            />
          </Box>
        </FormControl>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Typography sx={{ marginBottom: '10px', fontWeight: '500', color: '#00000099'}}>{i18n.t('serviceDraftsFilterModal.lastModifiedAt') as string}</Typography>
          <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
            <DatePicker
              label={i18n.t('keyboardDatePickerModalFilterService.from') as string}
              value={modifiedStartDate && new Date(modifiedStartDate)}
              onChange={date => setModifiedStartDate(date ?  date : null)}
              format="dd/MM/yyyy"
              slotProps={{ textField: { variant: 'standard', } }}
              sx={{ width: '45%', marginRight: '10px'}}
            />
            <DatePicker
              label={i18n.t('keyboardDatePickerModalFilterService.to') as string}
              value={modifiedEndDate && new Date(modifiedEndDate)}
              onChange={date => setModifiedEndDate(date ? date : null)}
              format="dd/MM/yyyy"
              slotProps={{ textField: { variant: 'standard', } }}
              sx={{ width: '45%'}}
            />
          </Box>
        </FormControl>
      </Box>
      <Box style={styles.footerContainer}>
        <Box
          onClick={closeModal}
          style={styles.buttonCancel}
        >
        {i18n.t('divModalFilterService.cancel') as string}
        </Box>
        <Button
          variant='contained'
          color='primary'
          onClick={handleClickFilter}
          style={styles.button}
        >
        {i18n.t('divModalFilterService.ok') as string}
        </Button>
      </Box>
    </Box>
  );
}

const styles = {
  container: {
    width: '40rem',
    height: '100%'
  },
  headerContainer: {
    height: '5rem',
    padding: '0 1rem 0 2rem',
    backgroundColor: 'green',
    color: '#fff',
    display: 'flex' as 'flex',
    alignItems: 'center' as 'center',
    justifyContent: 'space-between',
  },
  bodyContainer: {
    height: 'calc(100% - 10rem)',
    padding: '1rem 2rem',
    overflowY: 'auto' as 'auto',
    borderTop: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
  },
  chip: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#C5D1E3',
    margin: '0.5rem 0',
    borderRadius: 10,
    padding: '0.3rem 1rem',
    justifyContent: 'space-between'
  },
  footerContainer: {
    height: '5rem',
    padding: '0 2rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    flex: 1,
    backgroundColor: 'green',
    borderRadius: '2rem',
    padding: '0.5rem 1.5rem',
  },
  buttonCancel: {
    flex: 1,
    cursor: 'pointer' as 'pointer',
    color: 'grey',
    alignItems: 'center' as 'center',
    textAlign: 'center' as 'center',
  },
  clearFilter: {
    fontSize: '1rem',
    marginLeft: '2rem',
    color: '#fff',
    cursor: 'pointer',
    textDecoration: 'underline'
  },
}


export default ServiceDraftsFilterModal;
